import { render, staticRenderFns } from "./SpaceDetail.vue?vue&type=template&id=2a486120&"
import script from "./SpaceDetail.vue?vue&type=script&lang=js&"
export * from "./SpaceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports